import { isMinValueDate } from './formatDates';
import { patterns } from './regex';

const validatorTypes = {
    requiredString: {
        isValid: value => !!value.trim(),
        errorMessage: 'required',
    },
    requiredIdEntity: {
        isValid: value => !!value,
        errorMessage: 'required',
    },
    requiredDate: {
        isValid: date =>
            date &&
            Object.prototype.toString.call(date) === '[object Date]' &&
            !isNaN(date),
        errorMessage: 'required',
    },
    email: {
        isValid: value => value.trim().match(patterns.email),
        errorMessage: 'fill_valid_email',
    },
    phone: {
        isValid: value => value.trim().match(patterns.phone),
        errorMessage: 'fill_valid_phone',
    },
    bookingCode: {
        isValid: value => value.trim().match(patterns.bookingCode),
        errorMessage: 'booking_code_does_not_exist',
    },
    threeCharactersMinimum: {
        isValid: value => value.trim().match(patterns.threeCharactersMinimum),
    },
    requiredNumber: {
        isValid: value => !!value,
        errorMessage: 'required',
    },
    // custom
    customCustomSupplierChannel: {
        isValid: ({ IdAvailableSupplierChannel, CustomSupplierChannel }) => {
            if (IdAvailableSupplierChannel === 22) {
                return CustomSupplierChannel.trim().match(
                    patterns.threeCharactersMinimum
                );
            }
            return true;
        },
        errorMessage: 'minimium_three_characters',
    },
    customMaxAdults: {
        isValid: ({ maxAdults, minAdults }) => {
            if (maxAdults < minAdults) {
                return false;
            }
            return true;
        },
        errorMessage: 'max_adults_be_greater',
    },
    customMaxChildren: {
        isValid: ({ maxChildren, minChildren, adultsOnly }) => {
            if (adultsOnly) {
                return true;
            }
            if (maxChildren < minChildren) {
                return false;
            }
            return true;
        },
        errorMessage: 'max_child_be_greater',
    },
    validChildrenAgeRanges: {
        isValid: ({ adultAge, segments, adultsOnly }) => {
            if (adultsOnly) return true;
            if (!Number.isInteger(adultAge) || adultAge <= 0) return false;

            let previousAge = 0;
            return segments.every(({ age }) => {
                if (
                    !Number.isInteger(age) ||
                    age <= previousAge ||
                    age > adultAge
                ) {
                    return false;
                }
                previousAge = age;
                return true;
            });
        },
        errorMessage: 'invalid_age_ranges',
    },
    fromToDate: {
        isValid: ([fromValue, toValue]) => {
            //si fromValue y toValue tiene contenido, se comprueba si el DateFrom es menor o igual que el ToDate
            if (isMinValueDate(fromValue)) fromValue = null;
            if (isMinValueDate(toValue)) toValue = null;
            else if (fromValue && toValue) {
                const newDateFromDate = new Date(fromValue);
                const newDateToDate = new Date(toValue);
                return newDateFromDate <= newDateToDate;
            }
            //si ni fromValue ni toValue tiene contenido, se retorna válido
            return true;
        },
        errorMessage: `This date can't be earlier than From Date`,
    },
    floatGreaterOrEqualThan: {
        isValid: ({ value, min }) => {
            try {
                const parsed = parseFloat(value);
                return parsed >= min;
            } catch {
                return false;
            }
        },
        errorMessageFn: ({ min, errorMessage = `min_value_${min}` }) =>
            errorMessage,
    },
    requieredCollection: {
        isValid: value => Array.isArray(value) && value.length > 0,
        errorMessage: 'required',
    },
};

export const validateForm = form => {
    let errors = [];
    for (const fieldValidation in form) {
        const fieldValidatorProps = form[fieldValidation];
        const fieldErrors = fieldValidatorProps.validators.flatMap(
            validatorName => {
                const validatorType = validatorTypes[validatorName];
                const isValidFunction = validatorType?.isValid;
                const { value } = fieldValidatorProps;
                const isValid = isValidFunction(value);
                // fieldKey es la key del input al que se le quiere aplicar el mensaje de error
                const inputKey =
                    fieldValidatorProps?.inputKey || fieldValidation;
                if (isValid) return [];
                return [
                    {
                        inputKey,
                        errorMessage:
                            validatorType?.errorMessage ||
                            validatorType?.errorMessageFn?.(value),
                    },
                ];
            }
        );
        errors = errors.concat(fieldErrors);
    }
    return errors;
};
